
import { ActionTask, taskType } from "actions/types/task";
import { Action } from "actions/types/Action";
import { Event } from "event/types/Event";
import { UserProfile } from "profile/types/profile";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const openAiTasks = {

    async suggestTask(
        profile: UserProfile | null,
        event: Event | null,
        action: Action | null,
        taskList: ActionTask[] | null
      ): Promise<ActionTask> {
        const res = await fetch(`${API_URL}/actiontasks/suggest-task`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ profile, event, action, taskList }),
        });
    
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`Failed to fetch suggested task: ${errorText}`);
        }
    
        const data = (await res.json()) as ActionTask;
        return data;
      }
}    

export default openAiTasks;